var exports = {
  "kL": "GuildInvitesTab.module__container___OXFoMV",
  "wx": "GuildInvitesTab.module__header___OXFoMV",
  "DD": "GuildInvitesTab.module__title___OXFoMV",
  "VA": "GuildInvitesTab.module__subtitle___OXFoMV",
  "dc": "GuildInvitesTab.module__spinnerContainer___OXFoMV",
  "sJ": "GuildInvitesTab.module__invitesContainer___OXFoMV",
  "IH": "GuildInvitesTab.module__inviteList___OXFoMV",
  "eu": "GuildInvitesTab.module__inviteItems___OXFoMV",
};

module.exports = exports;
